import { AtlasApiClient } from '@ag1/atlas-api/client';
import { getQueryKeyForInternal } from '@portal/state/utils/getQueryKeyForInternal';
import { GetV53WrittenReviewsQuery, V53WrittenReview } from '@portal/types/review';
import { useQuery } from '@tanstack/react-query';
import { useGateValue } from '@statsig/react-bindings';
import { SSGates } from '@portal/state/context/StatsigContext/StatsigFlags';

export const queryKeyForV53WrittenReviews = () =>
  getQueryKeyForInternal({
    keys: ['v53-written-reviews']
  });

function useGetGetV53WrittenReviewsQuery(queries: GetV53WrittenReviewsQuery) {
  const enableNewReviewsUI = useGateValue(SSGates.enableNewReviewsUI);
  return useQuery({
    // do not store the reviews with query params keys which creates a separate cached
    // version; the reviews data should use a single data source for all cases of filter, sort & search
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeyForV53WrittenReviews(),
    queryFn: () => AtlasApiClient.get('/reviews', { queries, timeout: 5000 }),
    enabled: () => enableNewReviewsUI,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retryOnMount: false,
    staleTime: Infinity
  });
}

export function useGetV53WrittenReviews(queries: GetV53WrittenReviewsQuery) {
  const dataResponse = useGetGetV53WrittenReviewsQuery(queries);
  const { data, isPending, isError } = dataResponse;
  return {
    data: data
      ? {
          ...data,
          reviews: data.reviews as V53WrittenReview[]
        }
      : null,
    isPending,
    isError
  };
}
